import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const DeleteListingModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "DeleteListingModalContainer" */
      './DeleteListingModalContainer'
    ),
  loading: LoadingModal,
});
